/**
 * Условия фонового обновления доски (ITEM-16).
 *
 * Вынесено из SpacePage отдельной чистой функцией: это самая хрупкая часть
 * автообновления — тихий рефетч заменяет список записей целиком, и любой
 * пропущенный случай означает исчезнувший на глазах ввод.
 */

export interface BoardRefreshState {
  /** Вкладка в фоне (document.hidden) — незачем жечь запросы. */
  hidden: boolean;
  /** Уже идёт загрузка. */
  loading: boolean;
  /** Открыта карточка записи: внутри inline-правки без кнопки «Сохранить». */
  drawerOpen: boolean;
  /** Пользователь тащит карточку/строку — подмена списка собьёт перетаскивание. */
  dragging: boolean;
  /** Сколько строк выделено под массовую операцию. */
  selectionCount: number;
  /** Ещё догружаются страницы: рефетч вернёт только первую и потеряет остальные. */
  hasMorePages: boolean;
  /** Курсор в поле ввода/редакторе — там несохранённый текст. */
  focusInEditor: boolean;
}

export function canRefreshBoard(state: BoardRefreshState): boolean {
  if (state.hidden) return false;
  if (state.loading) return false;
  if (state.drawerOpen) return false;
  if (state.dragging) return false;
  if (state.selectionCount > 0) return false;
  if (state.hasMorePages) return false;
  if (state.focusInEditor) return false;
  return true;
}

/** Стоит ли курсор в поле, где может быть несохранённый текст. */
export function isFocusInEditor(el: Element | null): boolean {
  if (!el) return false;
  const html = el as HTMLElement;
  return (
    html.tagName === 'INPUT'
    || html.tagName === 'TEXTAREA'
    || html.isContentEditable === true
  );
}
